import { defineMessages } from 'react-intl';

const idPrefix = 'settings.institution-notifications';
const intersectPrefix = 'settings.institution-notifications-intersect';

const messages = defineMessages({
  institutionNotifications: {
    id: `${idPrefix}.pageTitle`,
    defaultMessage: 'Institution Notifications',
  },
  pageInstructions: {
    id: `${idPrefix}.pageInstructions`,
    defaultMessage: 'As an administrator you can subscribe users to receive additional notifications',
  },
  activeMatchHeading: {
    id: `${idPrefix}.ActiveMatchHeading`,
    defaultMessage: 'Naviance ActiveMatch',
  },
  intersectActiveMatchHeading: {
    id: `${intersectPrefix}.ActiveMatchHeading`,
    defaultMessage: 'Intersect Connection',
  },
  activeMatchWeeklyReportHeading: {
    id: `${idPrefix}.activeMatchWeeklyReportHeading`,
    defaultMessage: 'Naviance ActiveMatch Weekly Report',
  },
  intersectActiveMatchWeeklyReportHeading: {
    id: `${intersectPrefix}.activeMatchWeeklyReportHeading`,
    defaultMessage: 'Intersect Connection Weekly Report',
  },
  activeMatchWeeklyReportDescription: {
    id: `${idPrefix}.activeMatchWeeklyReportDescription`,
    defaultMessage: 'A weekly report with the number of new connections made through Naviance ActiveMatch',
  },
  intersectActiveMatchWeeklyReportDescription: {
    id: `${intersectPrefix}.activeMatchWeeklyReportDescription`,
    defaultMessage: 'A weekly report with the number of new Intersect connections made through Naviance.',
  },
  activeMatchWeeklyReportInstructions: {
    id: `${idPrefix}.activeMatchWeeklyReportInstructions`,
    defaultMessage: 'Choose who will receive email notifications',
  },
  additionalEmailsPlaceholder: {
    id: `${idPrefix}.additionalEmailsPlaceholder`,
    defaultMessage: 'Comma separated emails',
  },
  additionalEmailsLabel: {
    id: `${idPrefix}.additionalEmailsLabel`,
    defaultMessage: 'Add people outside of the Counselor Community.',
  },
  buttonSave: {
    id: `${idPrefix}.buttonSave`,
    defaultMessage: 'Save',
  },
  changeSuccessTitle: {
    id: `${idPrefix}.success-title`,
    defaultMessage: 'Success!',
  },
  changeSuccessDescription: {
    id: `${idPrefix}.success-description`,
    defaultMessage: 'You\'ve updated your notifications settings.',
  },
  failureDescription: {
    id: `${idPrefix}.failureDescription`,
    defaultMessage: 'Something unexpected happened. Please try your request again.',
  },
  invalidEmailAddresses: {
    id: `${idPrefix}.validationErrorMessage`,
    defaultMessage: 'Emails must be valid and separated by comma.',
  },
});

export default messages;
